import axios from "axios";
import {createAsyncThunk} from "@reduxjs/toolkit";

import { baseUrl } from "src/config";




const getPrivileges=createAsyncThunk("getprivileges",async ()=>{
    const res=await axios.get(
        `${baseUrl}/api/get-privileges-for-adminconsole`,
        { withCredentials: true }
      )
    return res.data.data
})


export {getPrivileges}